// @flow

/**
 * Subscription plans
 */
export default {
  subscriptionPlans: Laravel && Laravel.subscriptionPlans ? Laravel.subscriptionPlans : [],
}
